export function queryToObj(query) {
	let querySubtr = query.substring(1)
	return JSON.parse('{"' + querySubtr.replace(/&/g, '","').replace(/=/g,'":"') + '"}', function(key, value) { return key===""?value:decodeURIComponent(value)})
}

export function objToQuery(obj) {
	return Object.keys(obj).reduce(function(a,k){a.push(k+'='+encodeURIComponent(obj[k]));return a},[]).join('&')
}
